import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const attackForge = defineConnector({
  identifier: "attackForge",
  name: "AttackForge",
  tagLine: "Penetration testing management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://attackforge.example.com/api"),
  auth: headerAuth([
    { name: "X-SSAPI-KEY", value: { from: "secret", field: "apiKey" } },
    {
      name: "Content-Type",
      value: { from: "literal", value: "application/json" },
    },
  ]),
  steps: [
    {
      title: "Set up AttackForge",
      items: [
        {
          kind: "markdown",
          content:
            "In AttackForge, open **Profile** and copy your **User API Key**. Ask an administrator to grant the integration user access to the required **Self-Service RESTful API** methods, including **GetProjects** for the connection test. Enter your deployment’s API URL. See [API authentication](https://support.attackforge.com/app/modules/self-service-restful-api/getting-started).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "url",
          label: "API base URL",
          required: true,
          placeholder: "https://attackforge.example.com/api",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Enter your AttackForge deployment’s HTTPS URL followed by /api.",
        },
        {
          kind: "input",
          label: "User API Key",
          required: true,
          target: {
            kind: "secrets",
            field: "apiKey",
          },
          helperText:
            "A User API Key generated in AttackForge under Profile. The key is static, does not expire, and is supplied in the X-SSAPI-KEY request header.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://attackforge.example.com/api")
          .trim()
          .replace(/\/+$/, "") + "/ss/projects?limit=1",
      ...{ method: "GET", headers: { "Content-Type": "application/json" } },
    }),
  },
});
